import { getRoomDisplayName } from './roomDisplayName';
import { orderBy } from 'lodash';
import moment from 'moment';
import React from 'react';
import { _T } from '../../../include/appI18n';
import TourProgram from '../../TourSearch/components/TourDescription/TourProgram';
import { Availabilities } from '../types';
import { InternalFlightBaggageRows } from './FlightBaggageInfo';
function CollapsibleDateRange({ rangeStart, rangeEnd, format }) {
    return React.createElement(React.Fragment, null, rangeStart.isSame(rangeEnd) ? rangeStart.format(format || 'L') : `${rangeStart.format(format || 'L')} – ${rangeEnd.format(format || 'L')}`);
}
function CollapsibleDateTimeRange({ rangeStart, rangeEnd, showTimeAnyway }) {
    return (React.createElement("label", { className: "flight-datetime-container" },
        React.createElement("span", { className: "flight-info-part" },
            rangeStart.hours() == 0 && rangeStart.minutes() == 0 && !showTimeAnyway ? null : React.createElement("span", { className: "col-12 time" }, rangeStart.format('HH:mm')),
            React.createElement("span", { className: "col-12" }, rangeStart.format('L'))),
        rangeStart.isSame(rangeEnd) ? React.createElement(React.Fragment, null) : React.createElement(React.Fragment, null,
            React.createElement("span", { className: "mx-3" }, "-"),
            React.createElement("span", { className: "flight-info-part" },
                rangeEnd.hours() == 0 && rangeEnd.minutes() == 0 && !showTimeAnyway ? null : React.createElement("span", { className: "col-12 time" }, rangeEnd.format('HH:mm')),
                React.createElement("span", { className: "col-12" }, rangeEnd.format('L'))))));
}
const hasHtml = (value) => !!value && value.trim().length > 0;
function HtmlText({ value }) {
    if (!hasHtml(value))
        return null;
    return React.createElement("p", { dangerouslySetInnerHTML: { __html: value } });
}
function HtmlTextList({ values }) {
    const visibleValues = (values || []).filter(hasHtml);
    if (!visibleValues.length)
        return null;
    return React.createElement(React.Fragment, null, visibleValues.map((value, index) => React.createElement(HtmlText, { key: index, value: value })));
}
export function TourInformation(props) {
    var _a, _b, _c;
    const displayFlightAsTransportation = !!((_a = props.cart.configuration.flightConfiguration) === null || _a === void 0 ? void 0 : _a.displayFlightAsTransportation);
    const showExtendedInfo = !!props.cart.configuration.useExtendedCartPageDesign;
    const tour = props.service.tour;
    const tourEvents = ((_c = (_b = props.cart.tourDescription) === null || _b === void 0 ? void 0 : _b.tourEvents) === null || _c === void 0 ? void 0 : _c.length)
        ? props.cart.tourDescription.tourEvents
        : (props.service.tourEvents || []);
    const showTourExtendedInfo = showExtendedInfo && (hasHtml(tour.description)
        || hasHtml(tour.route)
        || hasHtml(tour.additionalCharge)
        || tourEvents.length > 0);
    const renderHotelService = (svc) => {
        var _a, _b, _c, _d, _e;
        return (React.createElement("div", { className: "info-list-item" },
            React.createElement("div", { className: "col-xs-4 col-md-3 info-list-item-header" },
                React.createElement("span", { className: "info-list-item-type" },
                    React.createElement("i", { className: "fa fa-moon-o mr-1" }),
                    " ",
                    _T.COMMON_HOTEL),
                React.createElement("span", { className: "info-list-item-title" }, svc.accommodation.hotelName),
                React.createElement("span", { className: "info-list-item-subtitle" },
                    React.createElement(CollapsibleDateRange, { rangeStart: moment(svc.beginDate), rangeEnd: moment(svc.endDate) }))),
            React.createElement("div", { className: "col-xs-8 col-md-9 info-list-item-body" },
                React.createElement("div", { className: "info-list-prop" },
                    React.createElement("span", { className: "info-list-prop-name" },
                        _T.COMMON_ROOM_CATEGORY,
                        ": "),
                    React.createElement("span", { className: "info-list-prop-val" }, getRoomDisplayName(((_a = svc.accommodation.originalRoomNameFromProvider) === null || _a === void 0 ? void 0 : _a.trim()) || ((_e = (_d = (_c = (_b = props.cart.tourDescription) === null || _b === void 0 ? void 0 : _b.priceItem) === null || _c === void 0 ? void 0 : _c.hotels) === null || _d === void 0 ? void 0 : _d.find((h) => h.serviceId == svc.serviceId)) === null || _e === void 0 ? void 0 : _e.originalRoomNameFromProvider), svc.accommodation.roomTypeName, svc.accommodation.roomCategoryName))),
                React.createElement("div", { className: "info-list-prop" },
                    React.createElement("span", { className: "info-list-prop-name" },
                        _T.COMMON_MEAL,
                        ": "),
                    React.createElement("span", { className: "info-list-prop-val" }, svc.accommodation.mealTypeName)),
                React.createElement("div", { className: "info-list-prop" },
                    React.createElement("span", { className: "info-list-prop-name" },
                        _T.COMMON_AVAILABILITY,
                        ": "),
                    React.createElement("span", { className: `info-list-prop-val order-status ${svc.accommodation.availability == Availabilities.Ok ? 'immediate' : 'request'}` }, svc.accommodation.availability == Availabilities.Ok ? _T.ROOM_AVAILABLE : _T.ROOM_ONREQUEST)))));
    };
    const renderTransferService = (svc) => (React.createElement("div", { className: "info-list-item" },
        React.createElement("div", { className: "col-xs-4 col-md-3 info-list-item-header" },
            React.createElement("span", { className: "info-list-item-type" },
                React.createElement("i", { className: "fa fa-cab mr-1" }),
                _T.COMMON_TRANSFER),
            React.createElement("span", { className: "info-list-item-title" }, svc.name),
            React.createElement("span", { className: "info-list-item-subtitle" },
                React.createElement(CollapsibleDateTimeRange, { rangeStart: moment(svc.beginDate), rangeEnd: moment(svc.beginDate), showTimeAnyway: svc.order === 0 }))),
        React.createElement("div", { className: "col-xs-8 col-md-9 info-list-item-body" },
            React.createElement("div", { className: "info-list-prop" },
                React.createElement("span", { className: "info-list-prop-name" },
                    _T.COMMON_ROUTE,
                    ": "),
                React.createElement("span", { className: "info-list-prop-val" },
                    svc.cityFrom.name,
                    " (",
                    svc.placeFrom.name,
                    ") \u2192 ",
                    svc.cityTo.name,
                    " (",
                    svc.placeTo.name,
                    ")")),
            svc.transferType.id != 0 ? React.createElement("div", { className: "info-list-prop" },
                React.createElement("span", { className: "info-list-prop-name" },
                    _T.TRANSFER_TYPE,
                    ": "),
                React.createElement("span", { className: "info-list-prop-val" }, svc.transferType.name)) : null,
            showExtendedInfo ? React.createElement(HtmlTextList, { values: [...(svc.transferDescriptions || []), ...(svc.transferConditions || [])] }) : null)));
    const renderExtraService = (svc) => {
        const isInsurance = props.cart.configuration.insuranceServiceClassId !== undefined && svc.serviceClassId == props.cart.configuration.insuranceServiceClassId;
        return (React.createElement("div", { className: "info-list-item" },
            React.createElement("div", { className: "col-xs-4 col-md-3 info-list-item-header" },
                React.createElement("span", { className: "info-list-item-type" },
                    React.createElement("i", { className: `fa ${isInsurance ? 'fa-heartbeat' : 'fa-plus'} mr-1` }),
                    " ",
                    isInsurance ? _T.COMMON_INSURANCE : _T.COMMON_EXTRA_SERVICES),
                React.createElement("span", { className: "info-list-item-title" }, svc.name),
                React.createElement("span", { className: "info-list-item-subtitle" },
                    React.createElement(CollapsibleDateRange, { rangeStart: moment(svc.beginDate), rangeEnd: moment(svc.endDate) }))),
            React.createElement("div", { className: "col-xs-8 col-md-9 info-list-item-body" }, showExtendedInfo ? React.createElement(HtmlText, { value: svc.serviceDescription }) : null)));
    };
    const renderExcursionService = (svc) => (React.createElement("div", { className: "info-list-item" },
        React.createElement("div", { className: "col-xs-4 col-md-3 info-list-item-header" },
            React.createElement("span", { className: "info-list-item-type" },
                React.createElement("i", { className: "fa fa-map mr-1" }),
                " ",
                _T.COMMON_EXCURSION),
            React.createElement("span", { className: "info-list-item-title" }, svc.name),
            React.createElement("span", { className: "info-list-item-subtitle" },
                React.createElement(CollapsibleDateRange, { rangeStart: moment(svc.beginDate), rangeEnd: moment(svc.endDate) }))),
        React.createElement("div", { className: "col-xs-8 col-md-9 info-list-item-body" }, showExtendedInfo ? React.createElement(HtmlText, { value: svc.serviceDescription }) : null)));
    const renderFlightService = (svc) => {
        var _a, _b;
        return (React.createElement("div", { className: "info-list-item" },
            React.createElement("div", { className: "col-xs-4 col-md-3 info-list-item-header" },
                React.createElement("span", { className: "info-list-item-type" },
                    React.createElement("i", { className: `fa ${displayFlightAsTransportation ? 'fa-train' : 'fa-plane'} mr-1` }),
                    " ",
                    displayFlightAsTransportation ? _T.COMMON_TRANSPORTATION : _T.COMMON_FLIGHT),
                !displayFlightAsTransportation ? React.createElement("span", { className: "info-list-item-title" }, svc.name) : null,
                React.createElement("span", { className: "info-list-item-subtitle" }, svc.externalFlight ?
                    React.createElement(CollapsibleDateTimeRange, { rangeStart: moment(svc.externalFlight.departureTime), rangeEnd: moment(svc.externalFlight.arrivalTime) }) :
                    ((_a = svc.calcFlights) === null || _a === void 0 ? void 0 : _a.length) ?
                        React.createElement(CollapsibleDateTimeRange, { rangeStart: moment(svc.calcFlights[0].dateDeparture), rangeEnd: moment(svc.calcFlights[svc.calcFlights.length - 1].dateArrival) }) :
                        React.createElement(CollapsibleDateRange, { rangeStart: moment(svc.beginDate), rangeEnd: moment(svc.endDate) }))),
            React.createElement("div", { className: "col-xs-8 col-md-9 info-list-item-body row no-gutters" },
                React.createElement("div", { className: "col-xs-12 col-md-6" },
                    React.createElement("div", { className: "info-list-prop" },
                        React.createElement("span", { className: "info-list-prop-name" },
                            _T.COMMON_ROUTE,
                            ": "),
                        React.createElement("span", { className: "info-list-prop-val" },
                            svc.cityFrom.name,
                            " \u2192 ",
                            svc.cityTo.name)),
                    !displayFlightAsTransportation ? React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "info-list-prop" },
                            React.createElement("span", { className: "info-list-prop-name" },
                                _T.FLIGHT_CLASS,
                                ": "),
                            svc.externalFlight ?
                                React.createElement("span", { className: "info-list-prop-val" },
                                    svc.externalFlight.airServiceClassName,
                                    " (",
                                    svc.externalFlight.airServiceClassAdditionalCode,
                                    ")") :
                                React.createElement("span", { className: "info-list-prop-val" },
                                    svc.flightClass.name,
                                    " (",
                                    svc.flightClass.code,
                                    ")")),
                        svc.externalFlight ?
                            React.createElement(React.Fragment, null,
                                React.createElement("div", { className: "info-list-prop" },
                                    React.createElement("span", { className: "info-list-prop-name" },
                                        _T.COMMON_AIRLINE,
                                        ": "),
                                    React.createElement("span", { className: "info-list-prop-val" }, svc.externalFlight.airlineName)),
                                svc.externalFlight.aircraftName ? React.createElement("div", { className: "info-list-prop" },
                                    React.createElement("span", { className: "info-list-prop-name" },
                                        _T.COMMON_AIRCRAFT,
                                        ": "),
                                    React.createElement("span", { className: "info-list-prop-val" }, svc.externalFlight.aircraftName)) : null) : (svc.airlineName ? React.createElement("div", { className: "info-list-prop" },
                            React.createElement("span", { className: "info-list-prop-name" },
                                _T.COMMON_AIRLINE,
                                ": "),
                            React.createElement("span", { className: "info-list-prop-val" }, svc.airlineName)) : null)) : null),
                React.createElement("div", { className: "col-xs-12 col-md-6" },
                    !displayFlightAsTransportation ? React.createElement(React.Fragment, null, svc.externalFlight ? React.createElement(React.Fragment, null,
                        svc.externalFlight.baggageCount > 0 || svc.externalFlight.baggageWeight > 0 ?
                            React.createElement("div", { className: "info-list-prop" },
                                React.createElement("span", { className: "info-list-prop-name" },
                                    _T.FLIGHT_SEARCH_BAGGAGE,
                                    ": "),
                                React.createElement("span", { className: "info-list-prop-val" },
                                    svc.externalFlight.baggageCount,
                                    "*",
                                    svc.externalFlight.baggageWeight.toFixed(0))) :
                            React.createElement("div", { className: "info-list-prop" },
                                React.createElement("span", { className: "info-list-prop-name" }, _T.FLIGHT_SEARCH_WITHOUT_BAGGAGE)),
                        svc.externalFlight.handBaggageCount > 0 || svc.externalFlight.handBaggageWeight > 0 ?
                            React.createElement("div", { className: "info-list-prop" },
                                React.createElement("span", { className: "info-list-prop-name" },
                                    _T.FLIGHT_SEARCH_HAND_BAGGAGE,
                                    ": "),
                                React.createElement("span", { className: "info-list-prop-val" },
                                    svc.externalFlight.handBaggageCount,
                                    "*",
                                    svc.externalFlight.handBaggageWeight.toFixed(0))) :
                            React.createElement("div", { className: "info-list-prop" },
                                React.createElement("span", { className: "info-list-prop-name" }, _T.FLIGHT_SEARCH_WITHOUT_HAND_BAGGAGE)),
                        svc.paymentDeadline ?
                            React.createElement("div", { className: "info-list-prop" },
                                React.createElement("span", { className: "info-list-prop-name" },
                                    _T.FLIGHT_SEARCH_PAYMENT_BEFORE,
                                    ": "),
                                React.createElement("span", { className: "info-list-prop-val" }, moment(svc.paymentDeadline).format("g"))) : null) : React.createElement(InternalFlightBaggageRows, { luggageDescription: svc.luggageDescription })) : null,
                    showExtendedInfo ? React.createElement(HtmlText, { value: (_b = svc.flightInfo) === null || _b === void 0 ? void 0 : _b.notes }) : null))));
    };
    const renderBusTransportationService = (svc) => (React.createElement("div", { className: "info-list-item" },
        React.createElement("div", { className: "col-xs-4 col-md-3 info-list-item-header" },
            React.createElement("span", { className: "info-list-item-type" },
                React.createElement("i", { className: "fa fa-cab mr-1" }),
                _T.COMMON_BUS_TRANSPORTATION),
            React.createElement("span", { className: "info-list-item-title" }, svc.name),
            React.createElement("span", { className: "info-list-item-subtitle" },
                React.createElement(CollapsibleDateTimeRange, { rangeStart: moment(svc.beginDate), rangeEnd: moment(svc.beginDate), showTimeAnyway: !svc.isBack }))),
        React.createElement("div", { className: "col-xs-8 col-md-9 info-list-item-body" },
            React.createElement("div", { className: "info-list-prop" },
                React.createElement("span", { className: "info-list-prop-name" },
                    _T.COMMON_ROUTE,
                    ": "),
                React.createElement("span", { className: "info-list-prop-val" },
                    svc.from.city.name,
                    " (",
                    svc.from.name,
                    ") \u2192 ",
                    svc.to.city.name,
                    " (",
                    svc.to.name,
                    ")")))));
    const extendedTourInfoBlock = showTourExtendedInfo ? (React.createElement("div", { className: "cart-tour-info cart-tour-info-extended" },
        React.createElement(HtmlText, { value: tour.description }),
        hasHtml(tour.route) ? React.createElement(React.Fragment, null,
            React.createElement("h6", null, _T.COMMON_ROUTE),
            React.createElement(HtmlText, { value: tour.route })) : null,
        hasHtml(tour.additionalCharge) ? React.createElement(React.Fragment, null,
            React.createElement("h6", null, _T.BOOKING_TOUR_ADDITIONAL_CHARGE),
            React.createElement(HtmlText, { value: tour.additionalCharge })) : null,
        tourEvents.length > 0 ? React.createElement(React.Fragment, null,
            React.createElement("h6", null, _T.COMMON_ITINERARY),
            React.createElement(TourProgram, { events: tourEvents })) : null)) : null;
    return (React.createElement("div", { className: showExtendedInfo ? '' : 'row cart-tour-info info-list' },
        extendedTourInfoBlock,
        !showExtendedInfo ? React.createElement(React.Fragment, null,
            React.createElement("div", { className: "col-xs-12" },
                React.createElement("hr", null)),
            orderBy(props.service.allTourServices, [(x => x.order === null || x.order === undefined ? 100 : x.order), (x => x.beginDate), (z => z.type == 'hotel' ? 0 : 1)]).map(s => React.createElement(React.Fragment, null,
                s.type == 'hotel' ? renderHotelService(s) :
                    s.type == 'transfer' ? renderTransferService(s) :
                        s.type == 'extra' ? renderExtraService(s) :
                            s.type == 'excursion' ? renderExcursionService(s) :
                                s.type == 'flight' ? renderFlightService(s) :
                                    s.type == 'busTransportation' ? renderBusTransportationService(s) : null,
                React.createElement("div", { className: "col-xs-12" },
                    React.createElement("hr", null))))) : null));
}
